import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

const PdfViewer3 = () => {
  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pdf.canhbao");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src={language === "vi" ? "/uploads/GoPaperless_CanhBaoRuiRoQuyenThuHoiChiaSeThongTinVNeIDV02.pdf" : "/uploads/GoPaperless_Cảnh_báo_rủi_ro_thu_hồi_chia_sẻ_thông_tin_VNeID_ENG_260813.pdf"}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="GoPaperless_CảnhBáoRủiRoThuHồiChiaSẻThôngTinVNeID"
      ></iframe>
    </div>
  );
};

export default PdfViewer3;
